export default "/images/smartico_logo.svg?4e3f6677278e98b6fda18fa16fe84df4";